module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av511-8285cc79339e7a7aab29f6b978c2c2b5.jpg";